



































import { Component } from 'vue-property-decorator';
import * as Locale from '@/plugins/i18n';
import * as env from '@/common/environment';
import { Component as TsxComponent } from 'vue-tsx-support';

import loading from '@/components/loading';
import LanguageIcon from './icons/LangaugeIcon.vue';

interface LanguageSelectorProps {
  /**
   * Function called when the dialog is expected to close.
   */
  onCloseDialog: () => unknown;
}

/**
 * Dropdown that selects a language.
 * NOTE: This component is used as a JSX component in the pleased application, and
 * the global i18n service is not available here, hence, we use the locale service directly
 * to listen for changes and reactivity.
 */
@Component({ directives: { loading }, components: { LanguageIcon } })
export default class LanguageSelector extends TsxComponent<LanguageSelectorProps> {
  readonly LANGUAGES = Locale.LANGUAGES;
  selected: Locale.SupportedLanguages = 'en';

  clearLocaleListener: Function | null = null;

  /**
   * The language currently loading. This is used as string to keep
   * track of which language is currently loading.
   */
  loading = '';

  get enabledLanguages () {
    return env.get('enabledLanguages') || [];
  }

  created () {
    this.selected = Locale.i18n.locale as Locale.SupportedLanguages;
    this.clearLocaleListener = Locale.addListener(({ current }) => {
      this.selected = current;
    });
  }

  beforeDestroy () {
    this.clearLocaleListener?.();
  }

  close () {
    this.$emit('closeDialog');
  }

  async changeLanguage (lang: Locale.SupportedLanguages) {
    this.loading = lang;
    try {
      await Locale.setLanguage(lang);
      this.close();
      // TODO: Handle error
    } finally {
      this.loading = '';
    }
  }
}
